import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSpaceMembersKey } from '../../utils/keys';
export const useRemoveSpaceMember = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.spaceMembers.remove(input), {
        onMutate: variables => {
            const spaceMembersKey = getSpaceMembersKey({
                variables: {
                    spaceId: variables.spaceId,
                },
            });
            queryClient.setQueriesData(spaceMembersKey, old => {
                var _a;
                return ({
                    ...old,
                    pages: (_a = old === null || old === void 0 ? void 0 : old.pages) === null || _a === void 0 ? void 0 : _a.map(page => {
                        var _a;
                        return ({
                            ...page,
                            edges: (_a = page === null || page === void 0 ? void 0 : page.edges) === null || _a === void 0 ? void 0 : _a.filter(edge => { var _a, _b, _c; return !((_a = variables === null || variables === void 0 ? void 0 : variables.memberIds) === null || _a === void 0 ? void 0 : _a.includes((_c = (_b = edge === null || edge === void 0 ? void 0 : edge.node) === null || _b === void 0 ? void 0 : _b.member) === null || _c === void 0 ? void 0 : _c.id)); }),
                        });
                    }),
                });
            });
        },
        onSettled: (data, error, variables) => {
            const spaceMembersKey = getSpaceMembersKey({
                variables: {
                    spaceId: variables.spaceId,
                },
            });
            queryClient.invalidateQueries(spaceMembersKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useRemoveSpaceMember.js.map